(ns frontend.view.modals.curtains.kpi-member-curtain.view
  (:require
   [clojure.string :as string]
   [common.entity :as entity]
   [common.localization :as loc :refer [field-name]]
   [common.schema.registry :as registry]
   [common.util :as cu]
   [frontend.state.current-session :as session]
   [frontend.view.entity :as f-entity]
   [frontend.view.modals.curtains.kpi-member-curtain.events :as events]
   [potpuri.core :refer [fn->]]
   [reagent.core :as r]
   [ui.components.modal.view :as modal]
   [ui.editors.labelled-input.view :as labelled-input]
   [ui.util :as uu]))

(defonce modal-key :curtain/kpi-member)

(defn processing
  [data-state]
  [:div
   {:class (uu/cm "p-8 absolute hidden left-0 right-0 bottom-0 top-0" (when (:processing? @data-state) "flex justify-center items-center"))}
   [:div
    {:class "flex flex-col gap-3"}
    [:i.fal.fa-spinner.fa-pulse.fa-4x]
    [:span (loc/tr :processing)]]])

(defn owner-selector
  [edit-state]
  (let [attribute :common/owner
        accounts (->> (session/active-accounts nil)
                      (sort-by (fn-> entity/display-string str string/lower-case)))
        field-schema {:field/attribute          attribute
                      :attribute                attribute
                      :field/data-type          :data.type/ref-single
                      :value-type               :entity
                      :field/entity-types       [:entity.type/account]
                      :field/default-visibility {:editor :editor.type/select
                                                 :grid   :editor.type/select}
                      :editor/type              :editor.type/select
                      :field/translations       {:en "Select our reporting contact person"}}
        value (get @edit-state attribute)
        options (->> accounts
                     (map (fn [c]
                            {:value (:db/id c)
                             :label (entity/display-string c)})))]
    [:div
     [labelled-input/view
      {:editor-type :editor.type/select
       :options     options
       :value       (->> options
                         (cu/filter-by :value value)
                         (first))
       :placeholder (loc/tr :select-placeholder)
       :label       (or (->> field-schema
                             :field/translations
                             :en)
                        (loc/tr attribute)
                        (when-let [fs (registry/get-field-schema @session/tenant-schema
                                                                 attribute)]
                          (field-name attribute fs)))
       :on-change   (fn [new-value]
                      (if (nil? new-value)
                        (swap! edit-state dissoc attribute new-value)
                        (swap! edit-state assoc attribute new-value)))}]]))

(defn contact-selector
  [edit-state]
  (let [attribute :kpi-member/contact
        persons (->> @session/all-persons
                     (remove :common/disabled?)
                     (remove (fn [p]
                               (->> p
                                    :person/universal-email-address
                                    string/blank?))))
        field-schema {:field/attribute             attribute
                      :attribute                   attribute
                      :field/data-type             :data.type/ref-single
                      :value-type                  :entity
                      :field/entity-types          [:entity.type/person]
                      :create-on-fly?              true
                      :field/default-authorization {:access/create :role/user}
                      :mandatory-entity-fields     [:person/universal-email-address]
                      :field/default-visibility    {:editor :editor.type/select
                                                    :grid   :editor.type/select}
                      :editor/type                 :editor.type/select
                      :field/translations          {:en "Select their reporting contact person"}}
        value (get @edit-state attribute)
        options (->> persons
                     (map (fn [c]
                            {:value (:db/id c)
                             :label (entity/display-string c)})))]
    [:div
     [labelled-input/view
      {:editor-type :editor.type/select
       :options     options
       :value       (->> options
                         (cu/filter-by :value value)
                         (first))
       :placeholder (loc/tr :select-placeholder)
       :label       (or (->> field-schema
                             :field/translations
                             :en)
                        (loc/tr attribute)
                        (when-let [fs (registry/get-field-schema @session/tenant-schema
                                                                 attribute)]
                          (field-name attribute fs)))
       :create!     (fn [input-str]
                      (f-entity/open-creator!
                       [:entity.type/person]
                       {:start-value           input-str
                        :named-value-attribute attribute
                        :skip-success-msg?     true
                        :on-ok!                (fn [{:keys [new-entity-id new-entity close-cb!]}]
                                                 (js/console.log "Create person ok " new-entity)
                                                 (swap! edit-state assoc attribute new-entity-id)
                                                 (when (fn? close-cb!)
                                                   (close-cb!)))}))
       :on-change   (fn [new-value]
                      (if (nil? new-value)
                        (swap! edit-state dissoc attribute new-value)
                        (swap! edit-state assoc attribute new-value)))}]]))

(defn company-selector
  [edit-state members]
  (let [attribute :kpi-member/asset
        selected-company-ids (->> members
                                  (map :kpi-member/asset)
                                  (doall))
        company-options (->> @session/all-companies
                             (remove (fn [c]
                                       (or (:common/disabled? c)
                                           (some #{(:db/id c)} selected-company-ids))))
                             (map (fn [c]
                                    {:value (:db/id c)
                                     :label (entity/display-string c)}))
                             (doall))
        field-schema {:field/attribute             attribute
                      :attribute                   attribute
                      :field/data-type             :data.type/ref-single
                      :value-type                  :entity
                      :field/entity-types          [:entity.type/company]
                      :create-on-fly?              true
                      :field/default-authorization {:access/create :role/user}
                      :field/default-visibility    {:editor :editor.type/select
                                                    :grid   :editor.type/select}
                      :editor/type                 :editor.type/select
                      :field/translations          {:en "Select company"}}
        value (get @edit-state attribute)]
    [:div
     [labelled-input/view
      {:editor-type :editor.type/select
       :options     company-options
       :value       (->> company-options
                         (cu/filter-by :value value)
                         (first))
       :label       (or (->> field-schema
                             :field/translations
                             :en)
                        (loc/tr attribute)
                        (when-let [fs (registry/get-field-schema @session/tenant-schema
                                                                 attribute)]
                          (field-name attribute fs)))
       :placeholder (loc/tr :select)
       :create!     (fn [input-str]
                      (f-entity/open-creator!
                       [:entity.type/company]
                       {:start-value           input-str
                        :named-value-attribute attribute
                        :skip-success-msg?     true
                        :on-ok!                (fn [{:keys [new-entity-id new-entity close-cb!]}]
                                                 (js/console.log "Create company ok " new-entity)
                                                 (swap! edit-state assoc attribute new-entity-id)
                                                 (when (fn? close-cb!)
                                                   (close-cb!)))}))
       :on-change   (fn [new-value]
                      (if (nil? new-value)
                        (swap! edit-state dissoc attribute new-value)
                        (swap! edit-state assoc attribute new-value)))}]]))

(defn view
  [{:keys [state]}]
  (let [edit-state (r/cursor state [:edit])]
    (fn [{:keys [shown? topmost? close-modal! props state]}]
      (let [{:keys [header-text
                    invite?
                    target                                                                          ;;kpi-category or kpi-cycle
                    members]}
            props
            header-text (or header-text (loc/tr :kpi-wizard/select-company-and-contacts))
            processing? (:processing @state)
            {:keys [kpi-member/asset kpi-member/contact common/owner]} @edit-state
            [asset-entity contact-entity owner-entity] (map #(get @session/entities %)
                                                            [asset contact owner])
            selected-companies (->> members
                                    (map :kpi-member/asset)
                                    set)
            error-text (cond
                         (or (nil? asset-entity)
                             (:common/disabled? asset-entity))
                         (loc/tr :please-select-company)
                         (contains? selected-companies asset)
                         (loc/tr :company-already-member)
                         (or (nil? contact-entity)
                             (:common/disabled? contact-entity))
                         (loc/tr :please-select-kpi-contact)
                         (or (nil? owner-entity)
                             (:common/disabled? owner-entity))
                         (loc/tr :please-select-kpi-owner)
                         (->> contact-entity
                              :person/universal-email-address
                              string/blank?)
                         (loc/tr :selected-contact-must-have-email)
                         :else nil)
            disabled? (boolean error-text)]
        [modal/view
         {:visible?      (and shown? topmost?)
          :hide!         close-modal!
          :backdrop      "static"
          :close-button? true
          :class         "relative"}
         header-text
         (if processing?
           [processing state]
           [:div
            {:class "flex flex-col gap-4 relative"}
            [company-selector edit-state members]
            [contact-selector edit-state]
            [owner-selector edit-state]])
         [:<>
          [modal/left-cancel-only close-modal! nil]
          [modal/right-single-button
           nil
           disabled?
           (fn [_]
             (when-not disabled?
               (events/add-member! edit-state state target invite? close-modal!)))
           (loc/tr :add)
           nil]]]))))
